import markdownExtensions from 'markdown-extensions';
export var mdx = ['.mdx'];
/** @type {string[]} */

export var md = markdownExtensions.map(function (
/** @type {string} */
d) {
  return '.' + d;
});